// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qr-overlay .logo {\n  padding: 10px 5px 5px 5px;\n  width: 230px;\n  filter: drop-shadow(4px 4px 4px #000);\n}\n\n.qr-overlay .flex-column {\n  align-items: flex-start;\n}\n\n.qr-overlay .code {\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
